import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIOS_APROVAR_CADASTRO_BEGIN,
  USUARIOS_APROVAR_CADASTRO_SUCCESS,
  USUARIOS_APROVAR_CADASTRO_FAILURE,
  USUARIOS_APROVAR_CADASTRO_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function aprovarCadastro(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIOS_APROVAR_CADASTRO_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissAprovarCadastroError() {
  return {
    type: USUARIOS_APROVAR_CADASTRO_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIOS_APROVAR_CADASTRO_BEGIN actions
export function* doAprovarCadastro(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioApi.aprovarCadastroPendente(action.data);
  } catch (err) {
    yield put({
      type: USUARIOS_APROVAR_CADASTRO_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIOS_APROVAR_CADASTRO_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIOS_APROVAR_CADASTRO_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIOS_APROVAR_CADASTRO_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchAprovarCadastro() {
  yield takeLatest(USUARIOS_APROVAR_CADASTRO_BEGIN, doAprovarCadastro);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_APROVAR_CADASTRO_BEGIN:
      return {
        ...state,
        aprovarCadastroPending: true,
        aprovarCadastroError: null,
      };

    case USUARIOS_APROVAR_CADASTRO_SUCCESS:
      return {
        ...state,
        registro: action.data,
        registros: state.registros.filter(registro => registro.codigo !== action.data.Codigo),
        aprovarCadastroPending: false,
        aprovarCadastroError: null,
      };

    case USUARIOS_APROVAR_CADASTRO_FAILURE:
      return {
        ...state,
        aprovarCadastroPending: false,
        aprovarCadastroError: action.data.error,
      };

    case USUARIOS_APROVAR_CADASTRO_DISMISS_ERROR:
      return {
        ...state,
        aprovarCadastroError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/aprovarCadastro.js